import { Component } from '@angular/core';

@Component({
    selector: 'atx-chat',
    template: `<div class="header">
    <span>Chat</span>
    <a href="#">(1 missatge nou)</a>
    <span class="aside">
                    <a class="chat" (click)="show && toggleShow()"></a>
                    <a class="show" (click)="!show && toggleShow()"></a>
                    <a class="close"></a>
                </span>
</div>
<div class="body"
     *ngIf="show">
    <atx-chat-detail class="p-0"></atx-chat-detail>
</div>
`,
    styles: [``],
})

export class AtxChatComponent {
    public show: boolean;

    public toggleShow() {
        this.show = !this.show;
    }
}
